import React from 'react';
import './ProductionSubpage.css';

const ElamyksiaVesilla = () => {
  return (
    <div className="production-subpage-container">
      <h1>Elämyksiä vesillä</h1>
      <i>Sivusto työn alla</i>
    </div>
  );
};

export default ElamyksiaVesilla;